import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { AuthService, GenesisUnitOfWork, AppInformationService } from 'app/core/core.module';
import { DxDataGridComponent } from 'devextreme-angular';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import _ from 'lodash';
import { OrderDetailComponent } from 'app/orders/order-detail/order-detail.component';
import { SharedModule } from 'app/shared/shared.module';

@Component({
    selector: 'app-change-history',
    templateUrl: './change-history.component.html',
    styleUrls: ['./change-history.component.scss'],
    standalone: false
})
export class ChangeHistoryComponent implements OnInit {
    entities: any;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(
        private uow: GenesisUnitOfWork,
        private router: Router,
        public auth: AuthService,
        private modalService: BsModalService,
        private appInfo: AppInformationService
    ) { }

    async ngOnInit() {
        this.getData();
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        this.entities = await this.uow.getAuditLogs({ orderByDesc: 'when' });
        this.appInfo.pleaseWaitHide();
    }

    showChanges(entity) {
        if (!entity.changes) {
            const data = JSON.parse(entity.data);
            console.log(data);
            entity.changes = data.Changes;
        }
        entity.showChanges = true;
    }

    hideChanges(entity) {
        entity.showChanges = false;
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            }
            // {
            //     widget: 'dxButton',
            //     options: {
            //         icon: 'refresh',
            //         elementAttr: { title: 'Reset Grid Layout' },
            //         onClick: () => {
            //             e.component.state({});
            //         },
            //     },
            //     location: 'after',
            // }
        );
    }

    async open(entity) {
        console.log(entity);
        return;
        //    const modalRef = this.modalService.show(OrderDetailComponent, {
        //        class: 'modal-lg',
        //        ignoreBackdropClick: true,
        //        keyboard: false,
        //        initialState: {
        //            orderId: orderId,
        //            showAsDialog: true,
        //        },
        //    });

        //    modalRef.content.result.subscribe(async (result) => {
        //        if (result.success) {
        //            // this.appInfo.pleaseWaitShow();
        //            // await this.getData();
        //            // this.appInfo.pleaseWaitHide();
        //        }
        //        modalRef.hide();
        //        this.uow.rollback();
        //    });
    }
}
